import React, { useState } from "react"; 
import ReactPlayer from "react-player/vimeo"; 
import PlayBtn from './../../assets/icons/teens/play.svg';
import "./VideoCointainerEvents.css";

interface VideoCointainerEventsProps {
  videoThumbnail: string;
  videoUrl: string;
}

const VideoCointainerEvents: React.FC<VideoCointainerEventsProps> = ({
  videoThumbnail,
  videoUrl,
}) => {
  const [isPlaying, setIsPlaying] = useState(false); 

  return (
    <div className="video-container-event">
      <div className="video-wrapper-event">
        {isPlaying ? (
          <div className="video-responsive">
            <ReactPlayer
              url={videoUrl}
              playing
              controls
              width="100%"
              height="100%"
              className="video-player-event"
            />
          </div>
        ) : (
          <div className="video-thumbnail-container" onClick={() => setIsPlaying(true)}>
            <img src={videoThumbnail} alt="Course Preview" className="video-thumbnail" />
            <div className="play-button">
              <img src={PlayBtn} alt="Play" className="play-icon" /> 
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoCointainerEvents;
